import React from 'react';
import { useAuth } from '../context/AuthContext';
import { useLocation } from 'react-router-dom';

interface AdminLayoutProps {
  children: React.ReactNode;
}

const AdminLayout: React.FC<AdminLayoutProps> = ({ children }) => {
  const { adminUser, logout } = useAuth();
  const location = useLocation();

  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      console.error('Çıkış hatası:', error);
    }
  };

  const menuItems = [
    { path: '/dashboard', icon: '📊', label: 'Dashboard' },
    { path: '/users', icon: '👥', label: 'Kullanıcılar' },
    { path: '/messages', icon: '💬', label: 'Mesajlar' },
    { path: '/chatbot', icon: '🤖', label: 'Chatbot Yönetimi' },
    { path: '/like-bot', icon: '💕', label: 'Beğeni Botu' },
    { path: '/account-deletion-requests', icon: '🗑️', label: 'Hesap Silme Başvuruları' },
    { path: '/deleted-users', icon: '📂', label: 'Silinen Kullanıcılar' },
    { path: '/point-applications', icon: '🪙', label: 'Puan Başvuruları' },
    { path: '/sales', icon: '💳', label: 'Satış Yönetimi' },
    { path: '/premium-subscriptions', icon: '💎', label: 'Premium Abonelikler' },
    { path: '/reports', icon: '📋', label: 'Kullanıcı Raporları' },
    { path: '/post-reports', icon: '📰', label: 'Post Raporları' },
    { path: '/developer-tools', icon: '🛠️', label: 'Geliştirici Araçları' },
    { path: '/fake-user-management', icon: '👤', label: 'Fake Kullanıcı Yönet' },
    { path: '/settings', icon: '⚙️', label: 'Ayarlar' },
  ];

  return (
    <div style={{ display: 'flex', minHeight: '100vh', backgroundColor: '#f4f6f9' }}>
      {/* Sidebar */}
      <div style={{
        width: '250px',
        backgroundColor: '#2c3e50',
        color: 'white',
        padding: '0',
        display: 'flex',
        flexDirection: 'column',
        boxShadow: '2px 0 5px rgba(0,0,0,0.1)'
      }}>
        {/* Logo/Header */}
        <div style={{ 
          padding: '1.5rem 1rem', 
          borderBottom: '1px solid #34495e',
          textAlign: 'center'
        }}>
          <div style={{
            width: '40px',
            height: '40px',
            borderRadius: '50%',
            backgroundColor: '#F78D93',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 0.5rem',
            fontSize: '20px'
          }}>
            D
          </div>
          <h3 style={{ 
            color: '#F78D93', 
            margin: 0,
            fontSize: '1.1rem',
            fontWeight: '600'
          }}>
            Datezy Admin
          </h3>
        </div>
        
        {/* Navigation Menu */}
        <nav style={{ flex: 1, padding: '1rem 0' }}>
          {menuItems.map((item) => {
            const isActive = location.pathname === item.path;
            return (
              <a
                key={item.path}
                href={item.path}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  padding: '0.75rem 1rem',
                  color: isActive ? '#F78D93' : '#bdc3c7',
                  textDecoration: 'none',
                  backgroundColor: isActive ? 'rgba(247, 141, 147, 0.1)' : 'transparent',
                  borderRight: isActive ? '3px solid #F78D93' : '3px solid transparent',
                  transition: 'all 0.2s ease'
                }}
              >
                <span style={{ 
                  marginRight: '0.75rem', 
                  fontSize: '1.1rem',
                  opacity: isActive ? 1 : 0.7
                }}>
                  {item.icon}
                </span>
                <span style={{ 
                  fontSize: '0.9rem',
                  fontWeight: isActive ? '500' : '400'
                }}>
                  {item.label}
                </span>
              </a>
            );
          })}
        </nav>

        {/* Admin bilgileri ve çıkış */}
        <div style={{ 
          borderTop: '1px solid #34495e', 
          padding: '1rem',
          backgroundColor: '#34495e'
        }}>
          {adminUser && adminUser.name && (
            <div style={{ marginBottom: '1rem' }}>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                marginBottom: '0.5rem'
              }}>
                <div style={{
                  width: '32px',
                  height: '32px',
                  borderRadius: '50%',
                  backgroundColor: '#F78D93',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginRight: '0.75rem',
                  fontSize: '14px',
                  fontWeight: 'bold'
                }}>
                  {adminUser.name.charAt(0).toUpperCase()}
                </div>
                <div>
                  <p style={{ 
                    fontSize: '0.85rem', 
                    fontWeight: 'bold',
                    margin: '0',
                    color: '#F78D93'
                  }}>
                    {adminUser.name}
                  </p>
                  <p style={{ 
                    fontSize: '0.7rem', 
                    color: '#95a5a6',
                    margin: 0
                  }}>
                    {adminUser.role === 'super_admin' ? 'Süper Admin' : adminUser.role === 'moderator' ? 'Moderatör' : 'Admin'}
                  </p>
                </div>
              </div>
            </div>
          )}
          
          {/* Geçici admin bilgisi (adminUser yokken) */}
          {(!adminUser || !adminUser.name) && (
            <div style={{ marginBottom: '1rem' }}>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                marginBottom: '0.5rem'
              }}>
                <div style={{
                  width: '32px',
                  height: '32px',
                  borderRadius: '50%',
                  backgroundColor: '#F78D93',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginRight: '0.75rem',
                  fontSize: '14px',
                  fontWeight: 'bold'
                }}>
                  A
                </div>
                <div>
                  <p style={{ 
                    fontSize: '0.85rem', 
                    fontWeight: 'bold',
                    margin: '0',
                    color: '#F78D93'
                  }}>
                    Admin User
                  </p>
                  <p style={{ 
                    fontSize: '0.7rem', 
                    color: '#95a5a6',
                    margin: 0
                  }}>
                    Süper Admin
                  </p>
                </div>
              </div>
            </div>
          )}
          
          <button
            onClick={handleLogout}
            style={{
              width: '100%',
              padding: '0.5rem',
              backgroundColor: '#e74c3c',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '0.85rem',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '0.5rem'
            }}
          >
            🚪 Çıkış Yap
          </button>
        </div>
      </div>

      {/* Main Content Area */}
      <div style={{ 
        flex: 1, 
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#f4f6f9'
      }}>
        {/* Top Header */}
        <div style={{
          backgroundColor: 'white',
          padding: '1rem 2rem',
          borderBottom: '1px solid #e0e6ed',
          boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
        }}>
          <h1 style={{
            margin: 0,
            fontSize: '1.5rem',
            color: '#2c3e50',
            fontWeight: '600'
          }}>
            Admin Panel
          </h1>
        </div>

        {/* Page Content */}
        <div style={{ 
          flex: 1, 
          padding: '2rem',
          overflow: 'auto'
        }}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default AdminLayout; 